<template>
<div class="stamps">
  <div class="card" :style="{
        'background-image': 'url(' + cardColors[stampCard.card_type] + ')'
      }">
    <div class="title">
      <div class="img">
        <img :src="rankImage[stampCard.card_type]" />
      </div>
      {{ cardRankLabel[stampCard.card_type] }}
      {{ stampCard.card_type_no }}
    </div>

    <div class="stamp_area" v-if="stampCard.stamps.length <= 5">
      <div class="line odd">
        <Stamp :stampCard="stampCard" idx="0" />
        <Stamp :stampCard="stampCard" idx="1" />
        <Stamp :stampCard="stampCard" idx="2" />
      </div>
      <div class="line">
        <Stamp :stampCard="stampCard" idx="3" />
        <Stamp :stampCard="stampCard" idx="4" />
      </div>
      <span class="copyright">{{ stampCard.copy_right }}</span>
    </div>
    <div class="stamp_area" v-if="stampCard.stamps.length > 5">
      <div class="line odd">
        <Stamp :stampCard="stampCard" idx="0" />
        <Stamp :stampCard="stampCard" idx="1" />
        <Stamp :stampCard="stampCard" idx="2" />
      </div>
      <div class="line">
        <Stamp :stampCard="stampCard" idx="3" />
        <Stamp :stampCard="stampCard" idx="4" />
        <Stamp :stampCard="stampCard" idx="5" />
        <Stamp :stampCard="stampCard" idx="6" />
      </div>
      <div class="line odd">
        <Stamp :stampCard="stampCard" idx="7" />
        <Stamp :stampCard="stampCard" idx="8" />
        <Stamp :stampCard="stampCard" idx="9" />
      </div>
      <span class="copyright">{{ stampCard.copy_right }}</span>
    </div>
  </div>
</div>
</template>

<script>
import {
  sumStampCount,
  rankName,
  rankImage,
  cardRankLabel,
  cardColors,
  dataFormat
} from '../../utils/StampUtil.js'
import Stamp from './CardBodyStamp'
export default {
  name: 'StampHistoryCardBody',
  props: ['stampCard'],
  components: {
    Stamp
  },
  data: function () {
    return {
      id: 0,
      page: 0,
      cardRankLabel,
      cardColors,
      rankImage
    }
  },
  created() {
    document.title = 'スタンプ獲得履歴詳細'
  },
  computed: {},
  methods: {
    sumStampCount,
    rankName,

    dataFormat,
    goBack: function () {
      this.$router.push({
        name: 'FAQ'
      })
    },
    imageUrl: (stamps, idx) => stamps[idx].image_url,
    stampedAt: (stamps, idx) => stamps[idx].stamped_at,
    numberAt: function (stamps, idx) {
      return stamps[idx].stamped_at ? '' : this.stampCard.stamp_start_num + idx
    }
  }
}
</script>

<style lang="scss" scoped>
.stamps {
  padding: 0 10px;
  width: 100%;
  height: 100%;
  display: flex;

  .card {
    text-align: center;
    width: 100%;

    overflow: hidden;
    background-size: 100% 100%;

    display: flex;
    flex-direction: column;

    .title {
      color: white;
      font-weight: bold;
      font-size: 24px;
      margin-top: 10px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      .img {
        height: 100%;
        margin-right: 10px;

        img {
          height: 100%;
        }
      }
    }

    .stamp_area {
      padding: 0 10px;
      margin: 10px 0;

      flex: 1;

      display: flex;
      flex-direction: column;
      justify-content: center;

      .copyright {
        color: #d4d4d4;
        font-size: 2.4vw;
        text-align: right;
        margin-top: 10px;
      }

      .line {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
